export default __webpack_public_path__ + "static/media/og-image.97431b95.png";